$('input[name="datesearch"]').datepicker({
    format: 'yyyy/mm/dd',
});

$(function () {
    $('input[name="timesearch"]').timepicker({
        timeFormat: 'HH:mm～',
        interval: 30,
        scrollbar: true,
        maxHour: 19,
        minHour: 7,
        dynamic: false,
        zIndex: 100
    });
});
getStopStation ()

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const stopStationId = urlParams.get('stop_station');

const btnSearch = $('#btnSearch');
const dateSearch = $('#datesearch');
const timeSearch = $('#timesearch');
const startStation = $('select[name="start_station"]');
const stopStation = $('select[name="stop_station"]');
const adult = $('#adult');
const child = $('#child');

btnSearch.on('click', function () {
    sessionStorage.setItem('dateSearch', dateSearch.val());
    sessionStorage.setItem('timeSearch', timeSearch.val());
    sessionStorage.setItem('startStation', startStation.find(":selected").val());
    sessionStorage.setItem('stopStation', stopStation.find(":selected").val());
    sessionStorage.setItem('adult', adult.val());
    sessionStorage.setItem('child', child.val());
});

if(!dateSearch.val()) {
    dateSearch.val(sessionStorage.getItem('dateSearch'));
}
if(!timeSearch.val()) {

    timeSearch.val(sessionStorage.getItem('timeSearch'));
}
if(!adult.val()) {
    adult.val(sessionStorage.getItem('adult'));

}
if(!child.val()) {
    child.val(sessionStorage.getItem('child'));
}

if(!startStation.find(":selected").val()) {
    getStopStation();
    startStation.val(sessionStorage.getItem('startStation')).change();
}
if(sessionStorage.getItem('stopStation')) {
    getStopStation();
    stopStation.val(sessionStorage.getItem('stopStation')).change();
}
if (location.pathname === '/' && Boolean(stopStation.find('option').length)) {
    sessionStorage.removeItem("dateSearch");
    sessionStorage.removeItem("timeSearch");
    sessionStorage.removeItem("adult");
    sessionStorage.removeItem("child");
    sessionStorage.removeItem("startStation");
    sessionStorage.removeItem("stopStation");
}

function getStopStation () {
    $.ajax({
        type: 'GET',
        url: $('#startStation').data('route'),
        data: {
            start_station: $('select[name="start_station"]').find('option:selected').val(),
            datesearch: $('#datesearch').val(),
        },
        dataType: 'json',
        success: data => {
            $('select[name="stop_station"]').empty();
            $('select[name="stop_station"]').append(`<option hidden="true" disabled selected>--${selectingMessage}--</option>`);
            for (const k in data) {
                const select = data[k].id === +stopStationId ? 'selected' : '';
                $('select[name="stop_station"]').append(`<option ${select} value=` + data[k].id + ' >' + data[k].title + (Boolean(data[k].is_clone_station) ? '（戻り）' : '' ) + '</option>');
            }
        }
    });
}




function startst(){//出発地を指定
    if ($('select[name=start_station]').val() === '24') {//出発地セット_東横INN富士山大月駅
        $(".pop_on.pop_start").css('display', "none");//すべての出発地を空にする
        $(".place.point.sq1 .pop_on.pop_start").css('display', "block");

    } else if ($('select[name=start_station]').val() === '36') {//出発地セット_東横INN富士河口湖大橋
        $(".pop_on.pop_start").css('display', "none");
        $(".place.point.sq2 .pop_on.pop_start").css('display', "block");

    } else if ($('select[name=start_station]').val() === '35') {//出発地セット_富士急ハイランド
        $(".pop_on.pop_start").css('display', "none");
        $(".place.point.sq3 .pop_on.pop_start").css('display', "block");

    } else if ($('select[name=start_station]').val() === '48') {//出発地セット_忍野八海
        $(".pop_on.pop_start").css('display', "none");
        $(".place.point.sq4 .pop_on.pop_start").css('display', "block");

    } else if ($('select[name=start_station]').val() === '44') {//出発地セット_東横INN御殿場駅前
        $(".pop_on.pop_start").css('display', "none");
        $(".place.point.sq5 .pop_on.pop_start").css('display', "block");

    } else if ($('select[name=start_station]').val() === '25') {//出発地セット_東横INN富士山三島駅
        $(".pop_on.pop_start").css('display', "none");
        $(".place.point.sq6 .pop_on.pop_start").css('display', "block");

    } else if ($('select[name=start_station]').val() === '46') {//御殿場プレミアムアウトレット
        $(".pop_on.pop_start").css('display', "none");
        $(".place_position.abs7 .pop_on.pop_start").css('display', "block");

    } else if ($('select[name=start_station]').val() === '37') {//大月駅
        $(".pop_on.pop_start").css('display', "none");
        $(".place_position.abs8 .pop_on.pop_start").css('display', "block");

    } else {//地図上にない場合
        $(".pop_on.pop_start").css('display', "none");
    }
    getStopStation();
};//出発地ここまで
$(document).ready(startst);
$("select[name=start_station]").change(startst);

function stopst(){//到着地
    if ($('select[name=stop_station]').val() === '24') {//到着地セット_東横INN富士山大月駅
        $(".pop_on.pop_stop").css('display', "none");//すべての到着地を空にする
        $(".place.point.sq1 .pop_on.pop_stop").css('display', "block");

    } else if ($('select[name=stop_station]').val() === '36') {//出発地セット_東横INN富士河口湖大橋
        $(".pop_on.pop_stop").css('display', "none");
        $(".place.point.sq2 .pop_on.pop_stop").css('display', "block");

    } else if ($('select[name=stop_station]').val() === '35') {//出発地セット_富士急ハイランド
        $(".pop_on.pop_stop").css('display', "none");
        $(".place.point.sq3 .pop_on.pop_stop").css('display', "block");

    } else if ($('select[name=stop_station]').val() === '48') {//出発地セット_忍野八海
        $(".pop_on.pop_stop").css('display', "none");
        $(".place.point.sq4 .pop_on.pop_stop").css('display', "block");

    } else if ($('select[name=stop_station]').val() === '44') {//出発地セット_東横INN御殿場駅前
        $(".pop_on.pop_stop").css('display', "none");
        $(".place.point.sq5 .pop_on.pop_stop").css('display', "block");

    } else if ($('select[name=stop_station]').val() === '25') {//出発地セット_東横INN富士山三島駅
        $(".pop_on.pop_stop").css('display', "none");
        $(".place.point.sq6 .pop_on.pop_stop").css('display', "block");

    } else if ($('select[name=stop_station]').val() === '46') {//御殿場プレミアムアウトレット
        $(".pop_on.pop_stop").css('display', "none");
        $(".place_position.abs7 .pop_on.pop_stop").css('display', "block");

    } else if ($('select[name=stop_station]').val() === '37') {//大月駅
        $(".pop_on.pop_stop").css('display', "none");
        $(".place_position.abs8 .pop_on.pop_stop").css('display', "block");

    } else {//地図上にない場合
        $(".pop_on.pop_stop").css('display', "none");
    }
}//到着地ここまで
$("select[name=stop_station]").change(stopst);

$(function(){
    var abs1 = $('select[name=start_station] option[value="24"]').text();
    $("p.abs1").text(abs1);

    var abs2 = $('select[name=start_station] option[value="36"]').text();
    $("p.abs2").text(abs2);

    var abs3 = $('select[name=start_station] option[value="35"]').text();
    $("p.abs3").text(abs3);

    var abs4 = $('select[name=start_station] option[value="48"]').text();
    $("p.abs4").text(abs4);

    var abs5 = $('select[name=start_station] option[value="44"]').text();
    $("p.abs5").text(abs5);

    var abs6 = $('select[name=start_station] option[value="25"]').text();
    $("p.abs6").text(abs6);

    var abs7 = $('select[name=start_station] option[value="46"]').text();
    $("p.abs7").text(abs7);

    var abs8 = $('select[name=start_station] option[value="37"]').text();
    $("p.abs8").text(abs8);

    $('p.abs').each(function(){
        var txt = $(this).html();
        $(this).html(txt.replace(/（/g,'<br>（'));
    });
});

//マップから選択
$('.map_labelon label.start.set1').on('click',function(){//出発地セット_東横INN富士山大月駅
    $("select[name=start_station]").val("24");
    startst();
    $('select[name=start_station] option[value="24"]').trigger("click");
});
$('.map_labelon label.start.set2').click(function(){//出発地セット_東横INN富士河口湖大橋
    $("select[name=start_station]").val("36");
    startst();
    $('select[name=start_station] option[value="36"]').trigger("click");
});
$('.map_labelon label.start.set3').click(function(){//出発地セット_富士急ハイランド
    $("select[name=start_station]").val("35");
    startst();
    $('select[name=start_station] option[value="35"]').trigger("click");
});
$('.map_labelon label.start.set4').click(function(){//出発地セット_忍野八海
    $("select[name=start_station]").val("48");
    startst();
    $('select[name=start_station] option[value="48"]').trigger("click");
});
$('.map_labelon label.start.set5').click(function(){//出発地セット_東横INN御殿場駅前
    $("select[name=start_station]").val("44");
    startst();
    $('select[name=start_station] option[value="44"]').trigger("click");
});
$('.map_labelon label.start.set6').click(function(){//出発地セット_東横INN富士山三島駅
    $("select[name=start_station]").val("25");
    startst();
    $('select[name=start_station] option[value="25"]').trigger("click");
});
$('.map_labelon label.start.set7').click(function(){//出発地セット_御殿場プレミアムアウトレット
    $("select[name=start_station]").val("46");
    startst();
    $('select[name=start_station] option[value="46"]').trigger("click");
});
$('.map_labelon label.start.set8').click(function(){//出発地セット_大月駅
    $("select[name=start_station]").val("37");
    startst();
    $('select[name=start_station] option[value="37"]').trigger("click");
});


$('.map_labelon label.stop.set1').click(function(){//到着地セット_東横INN富士山大月駅
    $("select[name=stop_station]").val("24");
    stopst();
    $('select[name=stop_station] option[value="24"]').trigger("click");
});
$('.map_labelon label.stop.set2').click(function(){//到着地セット_東横INN富士河口湖大橋
    $("select[name=stop_station]").val("36");
    stopst();
    $('select[name=stop_station] option[value="36"]').trigger("click");
});
$('.map_labelon label.stop.set3').click(function(){//到着地セット_富士急ハイランド
    $("select[name=stop_station]").val("35");
    stopst();
    $('select[name=stop_station] option[value="35"]').trigger("click");
});
$('.map_labelon label.stop.set4').click(function(){//到着地セット_忍野八海
    $("select[name=stop_station]").val("48");
    stopst();
    $('select[name=stop_station] option[value="48"]').trigger("click");
});
$('.map_labelon label.stop.set5').click(function(){//到着地セット_東横INN御殿場駅前
    $("select[name=stop_station]").val("44");
    stopst();
    $('select[name=stop_station] option[value="44"]').trigger("click");
});
$('.map_labelon label.stop.set6').click(function(){//到着地セット__東横INN富士山三島駅
    $("select[name=stop_station]").val("25");
    stopst();
    $('select[name=stop_station] option[value="25"]').trigger("click");
});
$('.map_labelon label.stop.set7').click(function(){//到着地セット__御殿場プレミアムアウトレット
    $("select[name=stop_station]").val("46");
    stopst();
    $('select[name=stop_station] option[value="46"]').trigger("click");
});
$('.map_labelon label.stop.set8').click(function(){//到着地セット__大月駅
    $("select[name=stop_station]").val("37");
    stopst();
    $('select[name=stop_station] option[value="37"]').trigger("click");
});

$('.map_labelon label').click(function(){
    var e = $(this).attr('for'); // for を取得
    var e = $('#' + e);          // for をセレクタに整形
    if ( e.prop('checked') ) {   // チェック済みなら
        e.prop('checked', false);  // チェックを外す
        return false;              // label のクリックを無効化
    }
});
